import { useState } from 'react';
import { useHandovers } from './hooks/useHandovers';
import { HandoverBanner } from './components/HandoverBanner';
import { HandoverDetail } from './components/HandoverDetail';

/**
 * Header indicator for the app shell: compact pill (desktop) / icon (mobile)
 * whenever the current user has an unacknowledged shift handover waiting.
 * Rendered inside the top header, next to date and clocked-in status. Realtime
 * updates arrive via the centralized realtimeStore (same query key as
 * the handover view — TanStack Query dedupes the fetch).
 *
 * Kept separate from HandoverView so AuthedApp can render it above the
 * routed content without duplicating the view's state.
 *
 * @param {Object} props
 * @param {Object} props.user - Current authenticated user.
 */
export function HandoverGlobalBanner({ user }) {
    const hook = useHandovers(user);
    const [selected, setSelected] = useState(null);

    return (
        <>
            <HandoverBanner incoming={hook.incoming} onOpen={h => setSelected(h)} />
            {selected && (
                <HandoverDetail
                    handover={hook.handovers.find(h => h.id === selected.id) ?? selected}
                    user={user}
                    hook={hook}
                    onClose={() => setSelected(null)}
                />
            )}
        </>
    );
}
